import SectionPlacement from './SectionPlacement'

export default SectionPlacement
// eslint-disable-next-line import/export
export * from './SectionPlacement'
